// Boleta
import DocumentoPage from "./DocumentoPage.js";

const Boleta = () => (
  <DocumentoPage
    title="Ingreso de Cotización Boleta"
    tipoDocumento="boleta"
    initialRut="55555555-5"
    initialLoading={true}
    showFilter={false}
  />
);

export default Boleta;